// extracted by mini-css-extract-plugin
export var changeIcon = "_46-4";
export var container = "_46-0";
export var divider = "_46-7";
export var externalLinkIcon = "_46-1";
export var green = "_46-5";
export var helpCircleIcon = "_46-3";
export var iconButton = "_46-2";
export var red = "_46-6";